(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Quick-add for the "Complete Your Ritual"-style product cards used in this grid.
  (function () {
    function openCartDrawer() {
      var d = document.getElementById('cart-drawer');
      if (d && typeof d.open === 'function') { try { d.open(); return true; } catch (e) {} }
      return false;
    }
    function addToCart(btn) {
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      btn.classList.add('is-loading');
      var body = new FormData(); body.append('id', btn.dataset.variantId); body.append('quantity', '1');
      var sec = document.querySelector('cart-items-component'); if (sec && sec.dataset.sectionId) body.append('sections', sec.dataset.sectionId);
      var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (data) {
          btn.classList.remove('is-loading'); btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          try { if (data && data.sections && sec && sec.dataset.sectionId && data.sections[sec.dataset.sectionId]) { var host = document.getElementById('shopify-section-' + sec.dataset.sectionId); if (host) { var tmp = document.createElement('div'); tmp.innerHTML = data.sections[sec.dataset.sectionId]; var inc = tmp.querySelector('#shopify-section-' + sec.dataset.sectionId) || tmp.firstElementChild; if (inc) host.innerHTML = inc.innerHTML; } } } catch (e) {}
          openCartDrawer();
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        })
        .catch(function () { btn.classList.remove('is-loading'); window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart'; });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-grid .we-rl__addbtn[data-variant-id]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  // Quick-add for the "Complete Your Ritual"-style product cards used in this grid.
  (function () {
    function openCartDrawer() {
      var d = document.getElementById('cart-drawer');
      if (d && typeof d.open === 'function') { try { d.open(); return true; } catch (e) {} }
      return false;
    }
    function addToCart(btn) {
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      btn.classList.add('is-loading');
      var body = new FormData(); body.append('id', btn.dataset.variantId); body.append('quantity', '1');
      var sec = document.querySelector('cart-items-component'); if (sec && sec.dataset.sectionId) body.append('sections', sec.dataset.sectionId);
      var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (data) {
          btn.classList.remove('is-loading'); btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          try { if (data && data.sections && sec && sec.dataset.sectionId && data.sections[sec.dataset.sectionId]) { var host = document.getElementById('shopify-section-' + sec.dataset.sectionId); if (host) { var tmp = document.createElement('div'); tmp.innerHTML = data.sections[sec.dataset.sectionId]; var inc = tmp.querySelector('#shopify-section-' + sec.dataset.sectionId) || tmp.firstElementChild; if (inc) host.innerHTML = inc.innerHTML; } } } catch (e) {}
          openCartDrawer();
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        })
        .catch(function () { btn.classList.remove('is-loading'); window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart'; });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-grid .we-rl__addbtn[data-variant-id]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
